import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FundrecommService = /** @class */ (function () {
    function FundrecommService(http) {
        this.http = http;
        this.checkMonth = [
            {
                number: 1,
                name: 'มกราคม'
            },
            {
                number: 2,
                name: 'กุมภาพันธ์'
            },
            {
                number: 3,
                name: 'มีนาคม'
            },
            {
                number: 4,
                name: 'เมษายน'
            },
            {
                number: 5,
                name: 'พฤษภาคม'
            },
            {
                number: 6,
                name: 'มิถุนายน'
            },
            {
                number: 7,
                name: 'กรกฎาคม'
            },
            {
                number: 8,
                name: 'สิงหาคม'
            },
            {
                number: 9,
                name: 'กันยายน'
            },
            {
                number: 10,
                name: 'ตุลาคม'
            },
            {
                number: 11,
                name: 'พฤศจิกายน'
            },
            {
                number: 12,
                name: 'ธันวาคม'
            }
        ];
    }
    FundrecommService.prototype.get_fundRecomList_top3 = function () {
        var _latestNewsUrl = cmsApi + '/get_fundRecomList_top3/';
        var _latestNewsBody = {};
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    FundrecommService.prototype.get_marketList_top3 = function () {
        var _latestNewsUrl = cmsApi + '/get_marketList_top3/';
        var _latestNewsBody = {};
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    FundrecommService.prototype.get_vdoList_top3 = function () {
        var _latestNewsUrl = cmsApi + '/get_vdoList_top3/';
        var _latestNewsBody = {};
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    FundrecommService.prototype.get_newsletterList_top3 = function () {
        var _latestNewsUrl = cmsApi + '/get_newsletterList_top3/';
        var _latestNewsBody = {};
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    FundrecommService.prototype.getvdo_list_notTop3 = function () {
        var _latestNewsUrl = cmsApi + '/getvdo_list_notTop3/';
        var _latestNewsBody = {};
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    FundrecommService.prototype.getnewsletter_listNotTop3 = function () {
        var _latestNewsUrl = cmsApi + '/getnewsletter_listNotTop3/';
        var _latestNewsBody = {};
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    FundrecommService.prototype.get_fundRecomList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_fundRecomList_active/';
        var _getNewsPeriodBody = { IsActive: '1', search: '' };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    FundrecommService.prototype.get_fundRecomById = function (fundRecomid) {
        var URL = cmsApi + '/get_fundRecomById';
        var body = { fundRecomid: fundRecomid };
        return this.http.post(URL, body);
    };
    FundrecommService.prototype.get_newsletterById = function (newsletter_id) {
        var URL = cmsApi + '/get_newsletterById';
        var body = { newsletter_id: newsletter_id };
        return this.http.post(URL, body);
    };
    FundrecommService.prototype.get_vdoById = function (vdo_id) {
        var URL = cmsApi + '/get_vdoById';
        var body = { vdo_id: vdo_id };
        return this.http.post(URL, body);
    };
    FundrecommService.prototype.changeFormatDate = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_1 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_1; })[0];
            return day + ' ' + monthTh['name'] + ' ' + year;
        }
    };
    FundrecommService.prototype.changeFormatDate_getdate = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_2 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_2; })[0];
            return day;
        }
    };
    FundrecommService.prototype.changeFormatDate_getMMyyyy = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_3 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_3; })[0];
            return monthTh['name'] + ' ' + year;
        }
    };
    FundrecommService.prototype.changeFormatDate_getDateEnd = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_week = d.getMonth();
            var end_of_month = new Date(d.getFullYear(), month_week + 1, 0);
            var first_day = new Date(d.getFullYear(), month_week, 1);
            return first_day.getDate() + '-' + end_of_month.getDate();
        }
    };
    FundrecommService.prototype.date_thai = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (day + ' ' + monthTh['name'] + ' ' + year);
    };
    FundrecommService.prototype.date_thai_dd = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (day);
    };
    FundrecommService.prototype.date_thai_mm = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (monthTh['name']);
    };
    FundrecommService.prototype.date_thai_yy = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (year);
    };
    FundrecommService.ngInjectableDef = i0.defineInjectable({ factory: function FundrecommService_Factory() { return new FundrecommService(i0.inject(i1.HttpClient)); }, token: FundrecommService, providedIn: "root" });
    return FundrecommService;
}());
export { FundrecommService };
